<div class="page-container">
	<mat-card class="mat-card-top">
		<div class="card-contents">
			<div class="rowTwo">
				<div class="mat-card-title">
					<h1 class="card-title">Resources for Agencies</h1>
				</div>
				<div class="actions-box">
					<mat-form-field appearance="outline">
						<input matInput #search (keyup)="applyFilter($event)" placeholder="Search"
							[readonly]="isPageReadOnly" />
						<mat-icon matSuffix>search</mat-icon>

					</mat-form-field>
				</div>
			</div>

			<div class="mat-card-top-paragraph">
				<h3>
					Seneca International want to ensure you and your staff are well
					equipped. We provide forms, guidelines, manuals and reference
					materials you can use to assist you in using our systems.
				</h3>
			</div>

			<mat-card-content class="newsfeed-content">
				<table mat-table [dataSource]="dataSource" matSort>
					<ng-container matColumnDef="DisplayName">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let element">
							<p>
								<a class="link" *ngIf="!IsFile(element)" [href]="element.Link"
									target="_blank">{{element.DisplayName}}</a>
								<a class="link" *ngIf="IsFile(element)"
									(click)="DownloadFile(element.ResourceID, element.FileName)">{{element.DisplayName}}</a>
								<br />{{ element.Description }}
							</p>
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
				</table>
				<mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons> </mat-paginator>
			</mat-card-content>
		</div>
	</mat-card>
</div>